
<template>
  <v-form ref="form" lazy-validation>
    <v-text-field v-model="pickup_location.name" :readonly="read_only" :rules="required" 
     label="Nome do Local de Retira" prepend-icon="mdi-pin-outline"></v-text-field>
    <v-text-field v-model="pickup_location.CNPJ" :readonly="read_only" :rules="cnpj"
     label="CNPJ" prepend-icon="mdi-comment" v-mask="'##.###.###/####-##'"></v-text-field>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'
export default {
  name: 'PickupLocationForm',
  mixins:[validations],
  data() {
    return {
    }
  },
  props:{
    pickup_location:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },
  },
}
</script>

<style scoped>

</style>